import { render } from "./People.vue?vue&type=template&id=ca6795a8&scoped=true"
import script from "./People.vue?vue&type=script&lang=ts"
export * from "./People.vue?vue&type=script&lang=ts"

import "./People.vue?vue&type=style&index=0&id=ca6795a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ca6795a8"

export default script